<template>
    <div role="row">
        <div role="columnheader" v-if="label">{{ label }}<span v-show="pointer" class="color-red">*</span></div>
        <div role="columnheader" v-else><slot name="title" /></div>
        <div role="cell">
            <slot></slot>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        label: String,
        pointer: Boolean,
    },
};
</script>
